import axios from 'axios'
import store from '~/store/index'

export default async (to, from, next) => {
	if (!store.state.details.form) {
		if (to.query.token) {
			try {
				const {data} = await axios.get('/api/token/check', {
					params: {
						token: to.query.token
					}
				})

				let step = null
				if (to.query.step) {
					step = parseInt(to.query.step)
				}

				await store.dispatch('details/setFormInformation', data.data);

				next({
					name: to.name,
					params: {
						step: step
					}
				})
			} catch (e) {
				if (e.response) {
					if (e.response.data) {
						if (!e.response.data.success && (e.response.data.code.includes('TKN-002'))) {
							next({
								name: 'invalid-application'
							})
						}  else if (!e.response.data.success && (e.response.data.code.includes('TKN'))) {
							next({
								name: 'invalid-token'
							})
						}
					}
				}
			}
		} else {
			next({
				name: 'invalid-token'
			})
		}
	} else {
		next()
	}
}



// WEBPACK FOOTER //
// ./resources/js/middleware/check-token.js